var re_ID = /^[a-zA-Z][12]\d{8}$/;
var re_resident = /^[A-Z][ABCD89]\d{8}$/;
var re_mail = /^([a-zA-Z0-9]+(?:[._-]+|[a-zA-Z0-9]+)*)@([a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,})$/;
var re_Tel = /^(09)[0-9]{8}$/;
//var re_zh = /^(?!.*[^\p{Script=Han}\p{L}])[^\s\p{P}\p{S}\d]+$/u;
var re_zh = /^[\p{Script=Han}\p{L}:：ʼ⌃ṟéɨʉ‧・\s]+$/u;//包含中英文、及原住民特殊符號，並允許空白和特殊符號‧，但不允許其他標點符號、符號和數字。
var re_num = /\d+/;
var re_addr = /^(\p{Script=Han}|\w|[-,.，])+$/u
var re_english = /^[a-zA-Z!@#$%^&*(),.?":;{}|<>\-\s]+$/;

var CheckData = {
    id(value) {
        if(re_ID.test(value)){
            return 'taiwan';
        }
        if(re_resident.test(value)){
            return 'resident';
        }
        return false;
    },
    mobile(value) {//如果手機格式正確回傳 true 錯誤回傳 false
        if(!re_Tel.test(value)){
            return false;
        }
        if(value.length != 10){
            return false;
        }
        return true;
    },
    email(value) {//如果 email 格式正確回傳 true 錯誤回傳 false
        return re_mail.test(value);
    },
    englishName(value){
        return re_english.test(value)
    },
    address(value) {
        if(!re_addr.test(value)){
            return false;
        }
        if(!value.includes("號")){
            return false;
        }
        return true;
    },
    name(value){
        if(!re_zh.test(value)){
            return false;
        }
        if(re_num.test(value)){
            return false;
        }
        return true;
    },
    convertToHalfWidth(value){
        return value
            .replace(/[\uFF01-\uFF5E]/g, (char) =>
                String.fromCharCode(char.charCodeAt(0) - 0xfee0)
            )
            .replace(/\u3000/g, " "); // Convert full-width spaces to half-width spaces
    },
}
export default CheckData;
